import { useMutation } from '@hapana/shared/web/services/gqty'

import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { useErrorHandler } from '@hapana/shared/web/hooks/errors.hooks'

export const useAddClientPrivateNote = (options) => {
  const { popDialog } = useDialog()
  const { onError } = useErrorHandler('settings:businessLocations.fields')

  const [mutate, state] = useMutation(
    (mutation, args) => {
      const result = mutation.addClientPrivateNote({
        clientId: args.clientId,
        siteId: args.siteId,
        text: args.text,
        date: args.date,
      })

      if (result) {
        result.id
      }

      return result
    },
    {
      onComplete: (data) => {
        popDialog()
        options?.onSuccess?.(data)
      },
      onError: (error) => {
        onError(error)
        options?.onError?.(error)
      },
    }
  )

  return {
    mutate: ({ clientId, siteId, text, date }) =>
      mutate({
        args: {
          clientId,
          siteId,
          text,
          date,
        },
      }),
    ...state,
  }
}
